/* eslint-disable quotes */
import { h } from 'vue';

const body = `<h4>Show moving object coordinates</h4>

<p>Show or hide coordinates of moving vertices or edge deformations.</p>`;

export function ShowMovingCoordinatesTooltip() {
    return h('div', { innerHTML: body });
}
